import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaBook, FaLightbulb, FaUsers, FaShieldAlt, FaInfoCircle } from "react-icons/fa";
import './PlaybooksToggleButton.css';
import "./PlaybooksToggleButton.css";

const PlaybooksToggleButton = ({ showPlaybooks, onToggle }) => {
    const [showInfo, setShowInfo] = useState(false);
    const { t } = useTranslation('playbooks');
    return (
        <div className="playbooks-toggle-btn-wrapper">
            <button
                className={`playbooks-toggle-btn upgraded ${showPlaybooks ? "active" : ""}`}
                onClick={onToggle}
                aria-pressed={showPlaybooks}
            >
                <div className="button-header">
                    <div className="button-icon">📚</div>
                    <div className="button-text-content">
                        <h3 className="button-title">{showPlaybooks ? t('playbooksTrigger.buttonTextHide', { defaultValue: 'Masquer les fiches outils' }) : t('playbooksTrigger.title', { defaultValue: 'Fiches outils' })}</h3>
                        <p className="button-subtitle">{t('playbooksTrigger.subtitle', { defaultValue: 'Accédez à toutes les fiches pratiques pour améliorer vos projets.' })}</p>
                    </div>
                    <span className="button-badge">{t('playbooksTrigger.badge', { defaultValue: 'Guide' })}</span>
                    <button
                        className="playbooks-info-btn"
                        type="button"
                        aria-label={t('playbooksTrigger.infoAria', { defaultValue: "Qu'est-ce que les fiches outils ?" })}
                        onClick={e => { e.stopPropagation(); setShowInfo(true); }}
                    >
                        <FaInfoCircle />
                    </button>
                </div>

                <div className="button-features">
                    <div className="button-feature"><span>🧑‍💻</span> <span>{t('playbooksTrigger.concepts.collaboration', { defaultValue: 'Collaboration' })}</span></div>
                    <div className="button-feature"><span>🔒</span> <span>{t('playbooksTrigger.concepts.security', { defaultValue: 'Sécurité' })}</span></div>
                    <div className="button-feature"><span>📈</span> <span>{t('playbooksTrigger.concepts.analysis', { defaultValue: 'Analyse' })}</span></div>
                </div>

                <div className="button-cta playbooks-trigger-cta">
                    <span className="button-cta-text">
                        <span className="cta-icon" style={{ marginRight: '8px', fontSize: '1.1em' }}>📚✨</span>
                        {showPlaybooks ? t('playbooksTrigger.buttonTextHide', { defaultValue: 'Masquer les fiches outils' }) : t('playbooksTrigger.buttonText', { defaultValue: 'Voir les fiches outils' })}
                    </span>
                </div>
            </button>
            {showInfo && (
                <div className="playbooks-info-modal-overlay" onClick={() => setShowInfo(false)}>
                    <div className="playbooks-info-modal" onClick={e => e.stopPropagation()}>
                        <button className="playbooks-info-modal-close" onClick={() => setShowInfo(false)} aria-label="Fermer la modal info">×</button>
                        {/* ...existing code for modal... */}
                        <div className="playbooks-btn-explainer modern-orientation">
                            <div className="explainer-header">
                                <span className="explainer-main-icon"><FaBook /></span>
                                <span className="explainer-title">{t('playbooksTrigger.modal.mainTitle', { defaultValue: 'Fiches Outils' })}</span>
                                <span className="explainer-guide">{t('playbooksTrigger.modal.guide', { defaultValue: 'GUIDE' })}</span>
                            </div>
                            <div className="explainer-icons-row">
                                <span className="explainer-icon" title={t('playbooksTrigger.modal.features.collaboration', { defaultValue: 'Collaboration' })}><FaUsers /></span>
                                <span className="explainer-icon" title={t('playbooksTrigger.modal.features.security', { defaultValue: 'Sécurité' })}><FaShieldAlt /></span>
                                <span className="explainer-icon" title={t('playbooksTrigger.modal.features.analysis', { defaultValue: 'Analyse' })}><FaLightbulb /></span>
                                <span className="explainer-icon" title={t('playbooksTrigger.modal.features.bestPractices', { defaultValue: 'Bonnes pratiques' })}><FaBook /></span>
                            </div>
                            <div className="explainer-desc modern">
                                <span className="explainer-highlight">{t('playbooksTrigger.modal.highlight', { defaultValue: 'Mini-guides interactifs pour chaque étape du projet :' })}</span><br />
                                <ul className="explainer-list">
                                    <li><FaUsers className="li-icon" /> {t('playbooksTrigger.modal.features.collaboration', { defaultValue: 'Collaboration' })}</li>
                                    <li><FaShieldAlt className="li-icon" /> {t('playbooksTrigger.modal.features.security', { defaultValue: 'Sécurité' })}</li>
                                    <li><FaLightbulb className="li-icon" /> {t('playbooksTrigger.modal.features.analysis', { defaultValue: 'Analyse' })}</li>
                                    <li><FaBook className="li-icon" /> {t('playbooksTrigger.modal.features.bestPractices', { defaultValue: 'Bonnes pratiques' })}</li>
                                </ul>
                                <div className="explainer-bottom-text">
                                    <span>{t('playbooksTrigger.modal.bottomText', { defaultValue: '🔎 Découvrez des solutions concrètes et des astuces directement applicables !' })}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PlaybooksToggleButton;